import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { fetchBlockersForSprint } from '../../../services/blockers';
import { BlockerItem } from '../components/SprintSummary/types';
import { useSprint } from '../contexts/SprintContext';

export function useBlockers(): UseQueryResult<BlockerItem[], Error> {
  const { selectedSprint } = useSprint();

  return useQuery<BlockerItem[], Error>({
    queryKey: ['blockers', selectedSprint?.id],
    queryFn: () => fetchBlockersForSprint(selectedSprint?.id),
    enabled: !!selectedSprint,
    select: (data) =>
      data.map((item) => ({
        ...item,
        checkIn: {
          id: item.id,
          createdAt: item.dateAdded,
          ticket: {
            id: item.id,
            ticketNumber: item.title.split(':')[0].trim(),
            title: item.title.split(':')[1]?.trim() || '',
            externalLink: item.externalLink,
          },
        },
      })),
  });
}
